import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MixedLoyaltyQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { map, tap } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { MixedLoyaltyItemModule } from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty/mixed-loyalty-item';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty/mixed-loyalty-item';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from '@ngx-translate/core';

function MixedLoyaltyListComponent_div_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelement(3, "fgbcl-mixed-loyalty-item", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("item", item_r7);
} }
function MixedLoyaltyListComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MixedLoyaltyListComponent_div_0_ng_container_1_ng_container_1_Template, 4, 1, "ng-container", 5);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mixedLoyaltyList_r2 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 1, mixedLoyaltyList_r2, (ctx_r3.pageNumber - 1) * ctx_r3.pageSize, (ctx_r3.pageNumber - 1) * ctx_r3.pageSize + ctx_r3.pageSize));
} }
function MixedLoyaltyListComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtext(2, "star");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 12);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 2, "featured.rewards.placeholder.title"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 4, "featured.rewards.placeholder.description"), " ");
} }
function MixedLoyaltyListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, MixedLoyaltyListComponent_div_0_ng_container_1_Template, 3, 5, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, MixedLoyaltyListComponent_div_0_ng_template_2_Template, 9, 6, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mixedLoyaltyList_r2 = ctx.ngIf;
    const _r4 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mixedLoyaltyList_r2.length)("ngIfElse", _r4);
} }
function MixedLoyaltyListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "ngb-pagination", 14);
    ɵngcc0.ɵɵlistener("pageChange", function MixedLoyaltyListComponent_div_2_Template_ngb_pagination_pageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.pageNumber = $event; })("pageChange", function MixedLoyaltyListComponent_div_2_Template_ngb_pagination_pageChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.scrollToTop(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("page", ctx_r1.pageNumber)("pageSize", ctx_r1.pageSize)("collectionSize", ctx_r1.collectionSize)("maxSize", 7);
} }
class MixedLoyaltyListComponent {
    constructor(mixedLoyaltyQuery) {
        this.mixedLoyaltyQuery = mixedLoyaltyQuery;
        this.pageSize = 9;
        this.pageNumber = 1;
    }
    ngOnInit() {
        this.mixedLoyaltyList$ = this.mixedLoyaltyQuery.selectFavouriteMixedLoyaltyItems().pipe(map((items) => items.slice(0, this.take)), tap((i) => (this.collectionSize = i.length)));
    }
    scrollToTop() {
        scrollTo(0, 0);
    }
}
MixedLoyaltyListComponent.ɵfac = function MixedLoyaltyListComponent_Factory(t) { return new (t || MixedLoyaltyListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MixedLoyaltyQuery)); };
MixedLoyaltyListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MixedLoyaltyListComponent, selectors: [["fgbcl-mixed-loyalty-list"]], inputs: { pageSize: "pageSize", pageNumber: "pageNumber", onlyFavourites: "onlyFavourites", take: "take" }, decls: 3, vars: 4, consts: [["class", "row", 4, "ngIf"], ["class", "pagination-container d-flex justify-content-center", 4, "ngIf"], [1, "row"], [4, "ngIf", "ngIfElse"], ["noRewardItems", ""], [4, "ngFor", "ngForOf"], [1, "col-md-6", "col-lg-4"], [1, "loyalty-item-container"], [3, "item"], [1, "no-items", "w-100", "text-center"], ["aria-hidden", "true", 1, "icon", "material-icons-two-tone", "no-results-placeholder-icon", "text-center"], [1, "no-results-placeholder-title", "mixed-loyalty-placeholder-title"], [1, "no-results-placeholder-text", "mixed-loyalty-placeholder-description", "mb-5"], [1, "pagination-container", "d-flex", "justify-content-center"], ["size", "sm", 3, "page", "pageSize", "collectionSize", "maxSize", "pageChange"]], template: function MixedLoyaltyListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MixedLoyaltyListComponent_div_0_Template, 4, 2, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵtemplate(2, MixedLoyaltyListComponent_div_2_Template, 2, 4, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.mixedLoyaltyList$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.collectionSize > ctx.pageSize);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.MixedLoyaltyItemComponent, ɵngcc4.NgbPagination], pipes: [ɵngcc2.AsyncPipe, ɵngcc2.SlicePipe, ɵngcc5.TranslatePipe], styles: [""] });
MixedLoyaltyListComponent.ctorParameters = () => [
    { type: MixedLoyaltyQuery }
];
MixedLoyaltyListComponent.propDecorators = {
    onlyFavourites: [{ type: Input }],
    take: [{ type: Input }],
    pageSize: [{ type: Input }],
    pageNumber: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MixedLoyaltyListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-mixed-loyalty-list',
                template: "<div class=\"row\" *ngIf=\"mixedLoyaltyList$ | async as mixedLoyaltyList\">\r\n  <ng-container *ngIf=\"mixedLoyaltyList.length; else noRewardItems\">\r\n    <ng-container\r\n      *ngFor=\"let item of mixedLoyaltyList | slice: (pageNumber - 1) * pageSize:(pageNumber - 1) * pageSize + pageSize\"\r\n    >\r\n      <div class=\"col-md-6 col-lg-4\">\r\n        <div class=\"loyalty-item-container\">\r\n          <fgbcl-mixed-loyalty-item [item]=\"item\"></fgbcl-mixed-loyalty-item>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n  <ng-template #noRewardItems>\r\n    <div class=\"no-items w-100 text-center\">\r\n      <div class=\"icon material-icons-two-tone no-results-placeholder-icon text-center\" aria-hidden=\"true\">star</div>\r\n      <div class=\"no-results-placeholder-title mixed-loyalty-placeholder-title\">\r\n        {{ 'featured.rewards.placeholder.title' | translate }}\r\n      </div>\r\n      <div class=\"no-results-placeholder-text mixed-loyalty-placeholder-description mb-5\">\r\n        {{ 'featured.rewards.placeholder.description' | translate }}\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n\r\n<div class=\"pagination-container d-flex justify-content-center\" *ngIf=\"collectionSize > pageSize\">\r\n  <ngb-pagination\r\n    [(page)]=\"pageNumber\"\r\n    [pageSize]=\"pageSize\"\r\n    [collectionSize]=\"collectionSize\"\r\n    (pageChange)=\"scrollToTop()\"\r\n    [maxSize]=\"7\"\r\n    size=\"sm\"\r\n  ></ngb-pagination>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.MixedLoyaltyQuery }]; }, { pageSize: [{
            type: Input
        }], pageNumber: [{
            type: Input
        }], onlyFavourites: [{
            type: Input
        }], take: [{
            type: Input
        }] }); })();

class MixedLoyaltyListModule {
}
MixedLoyaltyListModule.ɵfac = function MixedLoyaltyListModule_Factory(t) { return new (t || MixedLoyaltyListModule)(); };
MixedLoyaltyListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MixedLoyaltyListModule });
MixedLoyaltyListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NgbPaginationModule,
            MixedLoyaltyItemModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MixedLoyaltyListModule, { declarations: function () { return [MixedLoyaltyListComponent]; }, imports: function () { return [CommonModule,
        NgbPaginationModule,
        MixedLoyaltyItemModule, ɵngcc5.TranslateModule]; }, exports: function () { return [MixedLoyaltyListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MixedLoyaltyListModule, [{
        type: NgModule,
        args: [{
                declarations: [MixedLoyaltyListComponent],
                imports: [
                    CommonModule,
                    NgbPaginationModule,
                    MixedLoyaltyItemModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MixedLoyaltyListComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MixedLoyaltyListComponent, MixedLoyaltyListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-mixed-loyalty-mixed-loyalty-list.js.map